var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHexagonBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 39,
    viewBox: "0 0 42 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_bii_323_26329)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.975643 23.1094C-0.325214 20.8753 -0.325214 18.1247 0.975643 15.8906L7.82861 4.12105C9.13311 1.88066 11.5474 0.500001 14.1606 0.500001L27.8394 0.500001C30.4526 0.500001 32.8669 1.88066 34.1714 4.12105L41.0244 15.8906C42.3252 18.1247 42.3252 20.8752 41.0244 23.1094L34.1714 34.8789C32.8669 37.1193 30.4526 38.5 27.8394 38.5L14.1606 38.5C11.5474 38.5 9.13311 37.1193 7.82861 34.8789L0.975643 23.1094Z",
    fill: "#19191E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.46832 22.2403C1.48026 20.5433 1.48026 18.4567 2.46832 16.7597L9.32129 4.99018C10.3134 3.28635 12.1562 2.22727 14.1606 2.22727L27.8394 2.22727C29.8438 2.22727 31.6866 3.28635 32.6787 4.99019L39.5317 16.7597C40.5197 18.4567 40.5197 20.5433 39.5317 22.2403L32.6787 34.0098C31.6866 35.7136 29.8438 36.7727 27.8394 36.7727L14.1606 36.7727C12.1562 36.7727 10.3134 35.7136 9.32129 34.0098L2.46832 22.2403Z",
    stroke: "black",
    strokeWidth: 3.45455
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_bii_323_26329",
    x: -28.4422,
    y: -27.9422,
    width: 98.8845,
    height: 94.8845,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 14.2211
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_323_26329"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_323_26329",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.37573
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.18786
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_323_26329"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 37.1937
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_323_26329",
    result: "effect3_innerShadow_323_26329"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHexagonBlack);
export default __webpack_public_path__ + "static/media/hexagon-black.d12865bc8a2a85f4317d12dc8f692b19.svg";
export { ForwardRef as ReactComponent };